var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPureSciencesicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7958 22C29.7958 33.0457 26.3058 42 22.0005 42C17.6953 42 14.2052 33.0457 14.2052 22C14.2052 10.9543 17.6953 2 22.0005 2C26.3058 2 29.7958 10.9543 29.7958 22Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8982 28.8372C16.4528 34.36 7.05081 35.7761 4.8982 32.0001C2.74558 28.2241 8.65753 20.6859 18.1029 15.1631C27.5483 9.64024 36.9503 8.22413 39.1029 12.0001C41.2555 15.7761 35.3436 23.3143 25.8982 28.8372Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1021 28.8372C27.5475 34.36 36.9495 35.7761 39.1021 32.0001C41.2548 28.2241 35.3428 20.6859 25.8974 15.1631C16.4521 9.64024 7.05005 8.22413 4.89744 12.0001C2.74483 15.7761 8.65677 23.3143 18.1021 28.8372Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 22C26.0002 24.2091 24.2093 26 22.0002 26C19.791 26 18.0002 24.2091 18.0002 22C18.0002 19.7909 19.791 18 22.0002 18C24.2093 18 26.0002 19.7909 26.0002 22Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPureSciencesicon);
export default __webpack_public_path__ + "static/media/pure-sciences.icon.2abd6478d1547ece5fb4d785b08e0098.svg";
export { ForwardRef as ReactComponent };